<section class="container">
<div class="policy-container" dir="ltr">
    <h3>Refund <span> Policy </span></h3>
    <div class="text-start">
        <h2>Eligibility for Refund</h2>
        <ul>
            <li>Customers are eligible for a refund if they have not accessed more than three (3) videos of the purchased course.</li>
            <li>The refund request must be made within <strong>30 days</strong> from the date of purchase.</li>
            <li>If more than three (3) videos have been accessed, the course is considered used, and a refund will not be issued.</li>
            <li>Refunds are only applicable to courses purchased directly through <strong>Elbershama</strong>. Purchases made through third-party platforms must follow their respective refund policies.</li>
        </ul>

        <h2>How to Request a Refund</h2>
        <ol>
            <li>To initiate a refund request, please contact our support team at <strong>support@el-bershama.com</strong> with your order details.</li>
            <li>Our team will verify whether the eligibility criteria are met.</li>
            <li>If approved, the refund will be processed within <strong>7 days</strong> and credited back to the original payment method.</li>
        </ol>

        <h2>Exceptions</h2>
        <ul>
            <li>Refunds will not be granted for courses that have been fully accessed or completed.</li>
            <li>No refunds will be issued for discounted or promotional offers unless otherwise stated.</li>
            <li>Any refund request that does not meet the stated conditions will not be approved.</li>
        </ul>

        <p>We appreciate your understanding and support. If you have any questions, feel free to reach out to our customer service team.</p>

        <h2>Contact Us</h2>
        <p><strong>Email:</strong> support@el-bershama.com</p>
        <p><strong>Phone:</strong> +201013703712</p>

        <p><strong>Elbershama Team</strong></p>
    </div>    
  </div>
  </section>